export const avatarTheme = {
  defaultAvatarFill: '--medkit-avatar-default-avatar-fill',
  iconFill: '--medkit-avatar-icon-fill',
  iconHighlightBackgroundColor:
    '--medkit-avatar-icon-highlight-background-color',
  iconHighlightFill: '--medkit-avatar-icon-highlight-fill',
  textBackgroundColor: '--medkit-avatar-text-background-color',
  textColor: '--medkit-avatar-text-color',
}
